import { Box, Button, CircularProgress, Typography } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import { FONT_SERIF, WD } from '../../../warningDashboard/warningTheme';
import { describeRange } from '../utils/dates';

/** The page heading - "Technical Department / Team Workload", what is shown - with Refresh and "Log my time". */
export default function WorkloadHeader({ range, people, capacityPerDay, projectName, loading, loadedAt, onRefresh, onLogMyTime }) {
  return (
    <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={2}>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: WD.green }}>Technical Department</Typography>
        <Typography component="h1" sx={{ fontFamily: FONT_SERIF, fontSize: { xs: 24, md: 32 }, fontWeight: 600, lineHeight: 1.2, color: WD.ink, mt: 0.25 }}>
          Team Workload
        </Typography>
        <Typography sx={{ mt: 0.75, fontSize: 13.5, color: WD.inkMuted }}>
          {describeRange(range.from, range.to)} · {people} member{people === 1 ? '' : 's'} · {capacityPerDay}h capacity per person
          {projectName ? ` · ${projectName}` : ''}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
        <Button
          variant="outlined"
          onClick={onRefresh}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={14} /> : <RefreshRoundedIcon />}
          title={loadedAt ? `Updated ${loadedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` : undefined}
        >
          Refresh
        </Button>
        {onLogMyTime && (
          <Button variant="contained" startIcon={<ScheduleRoundedIcon />} onClick={onLogMyTime}>
            Log my time
          </Button>
        )}
      </Box>
    </Box>
  );
}
